import React, { useEffect, useState } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import SubHeader from '../../components/SubHeader.jsx';
import { mapFinalFormErrors } from '../../lib/utils.js';
import FileForm from '../../components/files/FileForm.jsx';
import {
  createFile,
  deleteFile,
  retrieveFile,
  selectFile,
  updateFile,
} from '../../modules/files.js';
import FilesFormHeader from '../../components/headers/PageHeaders/Files/FilesFormHeader.jsx';

const defaultValues = {
  name: null,
  url: null,
  groupRoles: [],
};

const mapErrors = mapFinalFormErrors('Failed to save file');

const mapStateToProps = (state, ownProps) =>
  createSelector(selectFile(ownProps.fileId), (file) => ({
    file,
    // Form is editing if fileId is provided
    editing: typeof ownProps.fileId !== 'undefined',
  }))(state);

const mapDispatchToProps = {
  createFile,
  updateFile,
  deleteFile,
  selectFile,
  retrieveFile,
};

const FileFormContainer = (props) => {
  const {
    fileId,
    deleteFile,
    editing,
    retrieveFile,
    file,
    title,
    initiativeId,
    isEditing,
    role,
    slug,
  } = props;

  const [selectedGroups, updateSelectedGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const onSubmit = (values) => {
    const {
      createFile,
      updateFile,
      editing,
      projectId,
      initiativeType,
      initiativeId,
    } = props;

    const submitPromise = editing
      ? updateFile(values)
      : createFile(values, projectId, initiativeType, initiativeId);

    return submitPromise
      .then(() => {
        window.history.back();
        return Promise.resolve();
      })
      .catch(mapErrors);
  };

  const handleDelete = (event) => {
    if (confirm('Are you sure you want to delete this file?')) {
      setIsLoading(true);
      event.preventDefault();

      deleteFile(fileId)
        .then(() => {
          window.history.back();
          return Promise.resolve();
        })
        .catch(mapErrors);
    }
  };

  const validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = 'Title is required';
    }

    if (!values.url) {
      errors.url = 'URL is required';
    }

    return errors;
  };

  useEffect(() => {
    if (editing) {
      retrieveFile(fileId);
    }

    setIsLoading(false);
  }, []);

  return (
    <React.Fragment>
      <FilesFormHeader
        slug={slug}
        editing={!!file}
        initiativeId={initiativeId}
      />

      <SubHeader flexJustify small>
        <h2>{title}</h2>
        {isEditing && (
          <Button
            className="m-l-12"
            bsStyle="danger"
            disabled={isLoading}
            onClick={handleDelete}
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
        )}
      </SubHeader>

      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <Form
                    onSubmit={onSubmit}
                    handleDelete={handleDelete}
                    validate={validate}
                    component={FileForm}
                    initialValues={file || defaultValues}
                    selectedGroups={selectedGroups}
                    role={role}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(FileFormContainer);
